import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { isEmpty, isObject } from "lodash";
import { utils, writeFile } from 'xlsx';
import { getAPARReport } from '../../../../store/actions/';
import Loader from "../../../../components/loader";


const APARReportView = (props) => {

    const [loading, setLoading] = useState(true);
    const [filteredReport, setFiltered] = useState([]);
    const [report, setReport] = useState([]);
    const [paramsData, setParamsData] = useState(props.paramsData);

    useEffect(() => {
        getReport();
    }, []);

    async function getReport() {
        const { invoiceNumber, billingFrom, billingTo } = props.paramsData;
        let response = await props.getAPARReport({ invoiceNumber, startDate: billingFrom, endDate: billingTo });
        let reportData = (response.payload || []).filter(comp => {
            return Object.values(comp).find(val => typeof val === 'object');
        });
        setReport(reportData);
        setFiltered(reportData);
        setLoading(false);
    };

    function searchAll(text) {
        if (text.length && text.length < 2) return;
        let searchRgx = new RegExp((text || /.+/), 'i');
        let searched = report.filter(client => {
            return searchRgx.test(JSON.stringify(client));
        }).map(client => {
            let copy = {};
            for (let key in client) {
                if (typeof client[key] !== 'object' || searchRgx.test(key)) {
                    copy[key] = client[key];
                };
            };
            return copy;
        });
        setFiltered(searched);
    };

    function exportToExcel() {
        let transformedData = transformDataForExport(filteredReport);
        let ws = utils.json_to_sheet(transformedData);
        let wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Discrepancy Report");
        writeFile(wb, "Billing_Discrepancy.xlsx");
    };

    function transformDataForExport(data) {
        return data.reduce((list, company) => {
            let { companyShortName } = company;
            for (let category in company) {
                if (isObject(company[category])) {
                    list.push({
                        companyShortName,
                        category,
                        APItems: company[category].numItems,
                        ARItems: company[category].totalItems,
                        diff: company[category].numItems - company[category].totalItems
                    });
                };
            };
            return list;
        }, []);
    };

    return (<div className="df ffc wp_report_page">
        <div className="df download_actns">
            <div className="mla">
                <button onClick={exportToExcel} disabled={loading} className="export_btn" title="export to excel"></button>
            </div>
        </div>
        <h6><span className="align-left">{`Invoice ${paramsData.invoiceNumber}`}</span><span className="align-right">{new Date(paramsData.invoiceDate).toLocaleDateString()}</span></h6>
        <h6>{`Billing Period: ${new Date(paramsData.billingFrom).toLocaleDateString()} - ${new Date(paramsData.billingTo).toLocaleDateString()}`}</h6>
        <div className="df filters_wrpr billing">
            <input
                type="text"
                onChange={(e) => searchAll(e.target.value)}
                placeholder="Search..."
            ></input>
        </div>
        {loading ? <Loader /> : (<div
            className="table_wrpr w75"
        >
            <div className="client_header align-items-center df justify-content-between" >
                <div className="header"></div>
                <div className="client_block_outer">
                    <div className="df fww acse client_block justify-content-between">
                        <h5 className="lw_clc_25 fwm">Category</h5>
                        <h5 className="lw_clc_25 fwm"># Items (AP)</h5>
                        <h5 className="lw_clc_25 fwm"># Items (AR)</h5>
                        <h5 className="lw_clc_25 fwm">Status</h5>
                    </div>
                </div>
            </div>

            <div className="client_block_scroll">
                {filteredReport?.map((client, index) => {
                    return (<div className="client_wrpr align-items-center df justify-content-between" key={client.shortName}>
                        <div className="header">
                            <h4 className="client_hdr">{client.companyShortName}</h4>
                        </div>
                        <div className="client_block_outer">

                            <div className="client_block">

                                {Object.keys(client).sort().map(Key => {
                                    return (
                                        isObject(client[Key]) && <div
                                            key={`${client.companyShortName}-${Key}`}
                                            className={`df fww acse w100 line_padding justify-content-between `}>
                                            <p className="lw_clc_25">{Key}</p>
                                            <p className={`lw_clc_25`}>{client[Key].totalItems}</p>
                                            <p className={`lw_clc_25 `}>{client[Key].numItems}</p>
                                            <p className={`lw_clc_25 ${client[Key].totalItems - client[Key].numItems > 0 ? "red" : client[Key].totalItems - client[Key].numItems < 0 ? "yellow" : "green"}`}>{client[Key].totalItems - client[Key].numItems}</p>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>)
                })}
            </div>
        </div>)}
    </div>)
};

const mapStateToProps = ({ APARComparisonReducer }) => {
    const { APAR_REPORT } = APARComparisonReducer;
    return { APAR_REPORT };
};

export default connect(mapStateToProps, {
    getAPARReport
})(APARReportView);
